import {Link} from "react-router-dom";
import {ScrollService} from "../service/ScrollService";
import {default as React} from "react";

export function Footer() {
    return (
        <div>
            <br/>
            <br/>
            <hr/>
            <br/>
            <div className="text-center text-muted">
                Copyright Statusmatcher LLC. All Rights Reserved. | <Link to="/about" onClick={ScrollService.scrollToTop}>About</Link> | <Link to="/contact" onClick={ScrollService.scrollToTop}>Contact</Link> | <Link to="/sitemap" onClick={ScrollService.scrollToTop}>Site Map</Link> | <Link to="/terms" onClick={ScrollService.scrollToTop}>Terms and Conditions</Link>
            </div>
            <br/>
        </div>
    );
}